<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-id"];
import { computed, inject, onBeforeUnmount, provide, useId, watch } from "vue";
import { useCommandView } from "../composables/private/useCommandView";
import {
  MagicCommandInstanceId,
  MagicCommandViewId,
  MagicCommandParentTree,
  MagicCommandItemId,
  MagicCommandViewActive
} from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicCommandView",
  props: {
    id: { type: String, required: false },
    initial: { type: Boolean, required: false, default: false }
  },
  setup(__props) {
    const parentTree = inject(MagicCommandParentTree, []);
    const instanceId = inject(MagicCommandInstanceId, void 0);
    const itemId = inject(MagicCommandItemId, void 0);
    if (!instanceId) {
      throw new Error("MagicCommandView must be nested inside MagicCommandProvider");
    }
    const mappedId = computed(() => __props.id ?? `magic-command-view-${useId()}`);
    const mappedParentTree = computed(() => [...parentTree, mappedId.value]);
    const mappedActive = computed(() => view.active);
    const { initializeView, deleteView, sortViewItems } = useCommandView(instanceId);
    const view = initializeView({
      id: mappedId.value,
      parent: { views: parentTree, item: itemId ?? "" },
      initial: __props.initial
    });
    provide(MagicCommandViewId, mappedId.value);
    provide(MagicCommandViewActive, mappedActive);
    provide(MagicCommandParentTree, mappedParentTree.value);
    watch(
      () => view?.items,
      () => {
        sortViewItems(mappedId.value);
      }
    );
    onBeforeUnmount(() => {
      deleteView(mappedId.value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        "data-id": mappedId.value,
        class: "magic-menu-view"
      }, [
        _renderSlot(_ctx.$slots, "default", {
          viewActive: _unref(view).active
        })
      ], 8, _hoisted_1);
    };
  }
});
</script>
